import { useEffect, useState } from "react";
import Loading from "../../gui/Loading/Loading";
import { TFoodEntry } from "../../shared/Meals";
import { IFoodAmount, IRecipe } from "../../shared/Recipes";
import { MealsFullscreen } from "../Dialogs/FullscreenDlg";
import EmptyList from "../EmptyList";
import FactsheetTotal from "../Factsheet/FactsheetTotal";
import { useRecipes } from "../RecipesProvider";
import RecipeCache from "../../data/RecipeCache";

function FoodRow(props:{entry:TFoodEntry}) {
    const {options} = useRecipes()
    const name = options?.find(item => item.id==props.entry.id)?.text || ""
    const unit = typeof(props.entry.id)=="number" ? props.entry.unit : (" serving" + (props.entry.amount==1 ? "" : "s"))
    return <div className="row flex between gap-24">
        <label className="w700">{name}</label>
        <div className="amount">{props.entry.amount}{unit}</div>

    </div>
}
export default function MealViewer(){
    const {item} = MealsFullscreen.useFullscreen()
    const [amounts,setAmounts] = useState<IFoodAmount[]|undefined>(undefined)

    const getFoodAmounts = (amounts:IFoodAmount[], recipe:IRecipe|null, portion:number) => {
        if (!recipe) return
        for(const food of recipe.foods){
            amounts.push({id:food.id, amount:food.amount*portion, unit:food.unit})
        }
    }

    const populateAmounts = async () => {
        const recipes = await RecipeCache.i.getRecipes()
        const amounts : IFoodAmount[] = []
        for(const food of item.foods){
            if (typeof(food.id)=="number") amounts.push(food as IFoodAmount)
            else getFoodAmounts(amounts, recipes.find(food.id, true), food.amount)
        }
        setAmounts(amounts)
    }

    useEffect(() => {populateAmounts()}, [item])

    const factsheet = amounts ? <FactsheetTotal foods={amounts}/> : <Loading className="mt-16"/>
    const items = item.foods.length ? 
        <><div className="foods">{item.foods.map(food => <FoodRow entry={food} key={food.id}/>)}</div>{factsheet}</> : 
        <EmptyList title="Meal items" msg="List is empty"/>
    return <div className="viewer">{items}</div>
}